"use client";

import { SectionContainerWithoutBorder } from "@/components/app/advertisements-consultants/advertisements-filter/list/details/SectionContainer";
import { SearchIcon } from "lucide-react";
import { useRouter } from "next/navigation";
import { Button } from "@/components/button";

export default function ChooseFile() {
  const router = useRouter();

  return (
    <section className="w-full px-4 mt-12 md:mt-18">
      <div className="flex flex-col lg:grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
        {/* Image */}
        <div className="w-full order-2 lg:order-1">
          <div className="w-full h-6 md:h-8 lg:h-10 to-transparent rounded-xl" />
          <img
            src="/assets/find-properties.png"
            className="rounded-xl w-full h-auto object-cover"
            alt="Find properties"
          />
          <div className="bottom-0 w-full h-6 md:h-8 lg:h-10 rounded-xl" />
        </div>

        {/* Text */}
        <div className="rounded-2xl w-full lg:h-80 mt-0 lg:mt-3 bg-white order-1 lg:order-2">
          <SectionContainerWithoutBorder title="">
            <div className="space-y-5 md:space-y-7 text-center lg:text-start p-4 md:p-6">
              <p className="text-sec-title text-2xl sm:text-3xl md:text-[38px] font-bold p-2 rounded mt-0 md:mt-2">
                به راحتی ملک دلخواه خود را پیدا کنید!
              </p>
              <p className="text-sm md:text-base font-normal text-ordinary leading-relaxed">
                در کمترین زمان ممکن و با استفاده از ابزارهای هوشمند، به راحتی
                جستجو کنید و از میان هزاران ملک مناسب، گزینه ایده‌آل خود را
                بیابید
              </p>

              <Button
                variant="bare"
                type="button"
                text="جستجوی در آگهی ها"
                iconPosition="start"
                iconNode={<SearchIcon size={20} />}
                className="group inline-flex h-12 md:h-14 items-center justify-center cursor-pointer gap-2 md:gap-3 rounded-full bg-primary px-6 md:px-10 text-sm md:text-md font-normal text-white transition-all hover:bg-[#3730d8] hover:shadow-xl hover:shadow-primary/30 active:scale-95 w-full sm:w-auto"
                onClick={() =>
                  router.push(
                    `/advertisements-consultants/advertisements-filter/list`,
                  )
                }
              />
            </div>
          </SectionContainerWithoutBorder>
        </div>
      </div>
    </section>
  );
}
